"use client";
import { motion } from "motion/react";
import { Icon } from "@iconify/react";
import { solutionsData } from "@/lib/about-data";
import { containerVariants, itemVariants } from "@/utils/animations";
import Link from "next/link";

export default function SolutionGrid() {
  return (
    <section className="py-24 bg-hero dark:bg-dark_b border-y border-border dark:border-white/5 transition-colors duration-300">
      <div className="max-w-[83.75rem] mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-primary font-bold tracking-widest text-sm uppercase">
            Our Solutions
          </span>
          <h2 className="text-40 font-bold text-midnight_text dark:text-white">
            Product Focus
          </h2>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {solutionsData.map((item, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className={`rounded-3xl border transition-all duration-300 relative overflow-hidden group flex flex-col h-full
                ${
                  item.isHighlight
                    ? "bg-primary text-white border-transparent shadow-xl hover:shadow-2xl hover:-translate-y-2"
                    : "bg-white dark:bg-white/5 border-border dark:border-white/10 hover:border-primary/50 dark:hover:border-primary/50 hover:shadow-lg hover:-translate-y-2"
                }`}
            >
              <Link
                href={item.link}
                className="flex flex-col h-full no-underline p-8"
              >
                {item.isHighlight && (
                  <>
                    <div className="absolute top-0 right-0 w-32 h-32 bg-primary/20 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2"></div>
                    <div className="absolute -right-4 -top-4 text-white/10 rotate-12 group-hover:scale-110 transition-transform duration-500">
                      <Icon icon={item.icon} width="140" />
                    </div>
                  </>
                )}

                <div
                  className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 transition-colors duration-300
                    ${
                      item.isHighlight
                        ? "group-hover:text-primary group-hover:bg-white text-white bg-white/20"
                        : "bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white"
                    }`}
                >
                  <Icon icon={item.icon} width="28" />
                </div>

                <h3
                  className={`text-xl font-bold mb-3 relative z-10 transition-colors ${
                    item.isHighlight
                      ? "text-midnight-text dark:text-white"
                      : "text-midnight_text dark:text-white group-hover:text-primary"
                  }`}
                >
                  {item.title}
                </h3>

                <p
                  className={`text-sm leading-relaxed relative z-10 mt-auto ${
                    item.isHighlight
                      ? "text-white/80"
                      : "text-muted dark:text-white/60"
                  }`}
                >
                  {item.desc}
                </p>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
